import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);
  const goToPrevious = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  return <div className="relative w-full max-w-2xl mx-auto" data-id="element-236">
      <div className="relative overflow-hidden rounded-xl shadow-2xl bg-white p-2 border border-slate-200" data-id="element-237">
        <div className="relative aspect-[3/4]" data-id="element-238">
          {images.map((image, index) => <img key={index} src={image} alt={`Slide ${index + 1}`} className={`absolute inset-0 w-full h-full object-cover rounded-lg transition-opacity duration-500 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-239" />)}
        </div>

        {/* Navigation buttons */}
        <button onClick={goToPrevious} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-900 p-2 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Previous image" data-id="element-240">
          <ChevronLeft className="w-6 h-6" data-id="element-241" />
        </button>
        <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-900 p-2 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Next image" data-id="element-242">
          <ChevronRight className="w-6 h-6" data-id="element-243" />
        </button>

        {/* Dots indicator */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-244">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-245" />)}
        </div>
      </div>
    </div>;
}